import { search } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/cnd/v1/config`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findCNDConfig(empresa_cnpj, setting, idUser) {
  return search(
    `${path}${
      idUser ? `/${idUser}` : ""
    }?empresa_cnpj=${empresa_cnpj}&setting=${setting}`,
    "GET",
    headers
  );
}

export async function updateCNDConfig(empresa_cnpj, setting, value, idUser) {
  return search(
    `${path}${
      idUser ? `/${idUser}` : ""
    }?empresa_cnpj=${empresa_cnpj}&setting=${setting}&value=${value}`,
    "POST",
    headers
  );
}
